if (!customElements.get('product-inventory')) {
  class ProductInventory extends HTMLElement {
    constructor() {
      super();
      // 🚀 Run instantly inside quick add
      if (this.closest('quick-add-drawer')) {
        this.initLazySection();
      } else {
        window.initLazyScript(this, this.initLazySection.bind(this));
      }
    }

    initLazySection() {
      this.section = this.closest('.js-product');
      this.inventoryNotice = this.querySelector('.js-inventory-notice');
      this.urgencyMessage = this.querySelector('.js-inventory-urgency');

      this.boundHandleVariantChange = this.handleVariantChange.bind(this);

      this.section.addEventListener('on:variant:change:early', this.boundHandleVariantChange);
      this.section.addEventListener('on:variant:change', this.boundHandleVariantChange);

      this.updateInventory(
        parseInt(this.dataset.inventoryQuantity, 10),
        this.dataset.variantAvailable === 'true',
        this.dataset.inventoryPolicy
      );
    }

    handleVariantChange(evt) {
      const variant = evt.detail?.variant;

      // Instant update: use early variant data immediately
      if (evt.type === 'on:variant:change:early' && variant) {
        this.updateInventory(
          parseInt(variant.inventory_quantity ?? 0, 10),
          !!variant.available,
          variant.inventory_policy || 'deny'
        );
        return;
      }

      // Final update: use refreshed Liquid inventory data
      const dataEl = document.querySelector('.js-inventory-data');

      let inventoryData = null;

      if (dataEl) {
        try {
          inventoryData = JSON.parse(dataEl.textContent);
        } catch (e) {
          inventoryData = null;
        }
      }

      if (variant || inventoryData) {
        this.updateInventory(
          parseInt(inventoryData?.inventory_quantity ?? variant?.inventory_quantity ?? 0, 10),
          !!(inventoryData?.available ?? variant?.available),
          inventoryData?.inventory_policy || variant?.inventory_policy || 'deny'
        );
      } else {
        this.updateInventory(0, false, 'deny');
        this.hidden = true;
      }
    }

    updateInventory(count, available, inventoryPolicy) {
      let inventoryLevel;

      if (count <= 0) {
        if (inventoryPolicy === 'continue') {
          inventoryLevel = 'backordered';
        } else if (available) {
          inventoryLevel = 'in_stock';
        } else {
          inventoryLevel = 'none';
        }
      } else if (count <= parseInt(this.dataset.thresholdVeryLow, 10)) {
        inventoryLevel = 'very_low';
      } else if (count <= parseInt(this.dataset.thresholdLow, 10)) {
        inventoryLevel = 'low';
      } else {
        inventoryLevel = 'normal';
      }

      if (((this.dataset.showNotice === 'always'
        || (this.dataset.showNotice === 'low' && inventoryLevel.includes('low')))
        && !(inventoryLevel === 'backordered' && this.dataset.showNoStockBackordered === 'false'))) {
        this.hidden = false;

        this.setAttribute('data-inventory-level', inventoryLevel);

        if (inventoryLevel === 'backordered') {
          this.inventoryNotice.innerText = theme.strings.backordered;
        } else if (inventoryLevel === 'very_low') {
          this.inventoryNotice.innerText = theme.strings.onlyXLeft.replace('[quantity]', count);
        } else if (inventoryLevel === 'low') {
          this.inventoryNotice.innerText = theme.strings.lowStock.replace('[quantity]', count);
        } else if (inventoryLevel === 'normal' || inventoryLevel === 'in_stock') {
          this.inventoryNotice.innerText = theme.strings.inStock.replace('[quantity]', count);
        } else if (inventoryLevel === 'none') {
          this.inventoryNotice.innerText = theme.strings.noStock;
        }

        if (this.urgencyMessage) {
          if (inventoryLevel === 'very_low') {
            this.urgencyMessage.innerHTML = this.dataset.textVeryLow;
          } else if (inventoryLevel === 'low') {
            this.urgencyMessage.innerHTML = this.dataset.textLow;
          } else if (inventoryLevel === 'backordered') {
            this.urgencyMessage.innerHTML = this.dataset.textNoStockBackordered;
          } else if (inventoryLevel === 'normal' || inventoryLevel === 'in_stock') {
            this.urgencyMessage.innerHTML = this.dataset.textNormal;
          } else if (inventoryLevel === 'none') {
            this.urgencyMessage.innerHTML = this.dataset.textNoStock;
          }
        }
      } else {
        this.hidden = true;
      }
    }
  }

  customElements.define('product-inventory', ProductInventory);
}